module.exports = __webpack_public_path__ + "react.3FE8qDn9.png";